import * as React from "react"
import {
  PlayButton,
  PauseIcon,
  PlayIcon,
  ContainerIcon
} from "../custom-player.styled"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"

export interface PlayPauseButtonProps {
  paused: boolean
  playVideo: (event: React.MouseEvent<HTMLOrSVGElement, MouseEvent>) => void
  pauseVideo: (event: React.MouseEvent<HTMLOrSVGElement, MouseEvent>) => void
  handleTouchStart: (event: React.TouchEvent<HTMLDivElement>) => void
  handleOnTouchEndStop: (event: React.TouchEvent<HTMLDivElement>) => void
  handleOnTouchEndPlay: (event: React.TouchEvent<HTMLDivElement>) => void
}

const _PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  paused,
  playVideo,
  pauseVideo,
  handleTouchStart,
  handleOnTouchEndStop,
  handleOnTouchEndPlay
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <PlayButton
      type="button"
      roomStyles={roomStyles}
      // onFocus={e => e.target.blur()}
    >
      {!paused && paused !== undefined ? (
        <ContainerIcon
          roomStyles={roomStyles}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleOnTouchEndStop}
        >
          <PauseIcon onClick={pauseVideo} />
        </ContainerIcon>
      ) : (
        <ContainerIcon
          roomStyles={roomStyles}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleOnTouchEndPlay}
        >
          <PlayIcon onClick={playVideo} />
        </ContainerIcon>
      )}
    </PlayButton>
  )
}

export const PlayPauseButton = React.memo(_PlayPauseButton)
